<div class="chat-container mt-0 ps-2 pe-2 pb-0">
  <div class="chat-toolbar mt-0">
    <div class="toolbar-content justify-content-between">
      <div class="d-flex align-items-center justify-content-start">
        <button mat-icon-button [matMenuTriggerFor]="menu" [tabIndex]="-1">
          <mat-icon style="color: #757575;">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <div mat-menu-item (click)="$event.stopPropagation()">
            <mat-slide-toggle 
              [(ngModel)]="aiChatService.isAutoModeEnabled" 
              color="primary">
               Autonomous mode
            </mat-slide-toggle>
          </div>
          <button mat-menu-item (click)="clearChat()">Clear chat</button>
          <button mat-menu-item (click)="closeChat()">Close</button>
        </mat-menu>
        <img src="../../../../assets/images/ai/rachel-ai10.png" alt="Rachel" class="profile-pic ms-2" />
        <span class="user-name" style="color: #673ab7;">Rachel</span>
      </div>
      <div class="toolbar-actions">
        <button mat-icon-button (click)="toggleSize()" [tabIndex]="-1">
          <mat-icon style="color: #757575;">
            {{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}
          </mat-icon>
        </button>
        <button mat-icon-button (click)="toggleExpand()" [tabIndex]="-1">
          <mat-icon style="color: #757575;">minimize</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div
    class="chat-window rounded-bottom"
    #chatWindow
    (scroll)="onChatWindowScroll()"
    (wheel)="onChatWindowUserScroll()"
    (touchmove)="onChatWindowUserScroll()"
    (pointerdown)="onChatWindowUserScroll()"
  >
    <div class="chat-header mt-2 mb-4 text-center">
      <b>
        <span style="font-size: 24px;">How can </span>
        <span style="font-size: 30px; color: #673ab7;">Rachel</span>
        <span style="font-size: 24px;"> help?</span>
      </b>
    </div>

    <div class="prompt-starters" *ngIf="shouldShowPromptStarters(aiChatService.chatHistory$ | async)">
      <button
        type="button"
        class="prompt-starter"
        *ngFor="let prompt of getPromptStarters()"
        (click)="usePromptStarter(prompt)"
      >
        <mat-icon aria-hidden="true">north_east</mat-icon>
        <span>{{ prompt }}</span>
      </button>
    </div>

    <div
      *ngFor="let message of aiChatService.chatHistory$ | async"
      class="message"
      [ngClass]="[message.sender, getGeneratedUiBlocks(message).length ? 'message--generated-ui' : '']"
    >
      <mat-card [@messageAnimation]="message.sender">
        <div class="message-export-content" #messageExportContent>
        <!-- 1. Analytical Text -->
        <div
          *ngIf="!message.text.includes('[[COMPANY_CARD]]')"
          class="generated-text-body"
          [innerHTML]="message.text | safeHtml"
        ></div>
        <div
          *ngIf="message.text.includes('[[COMPANY_CARD]]')"
          class="generated-text-body"
          [innerHTML]="message.text.split('[[COMPANY_CARD]]')[0] | safeHtml"
        ></div>
        
        <!-- 2. Native Data Table -->
        <ng-container *ngIf="!message.isTyping && message.sender === 'bot' && (message.buyercaddySource?.length || message.geminiSources?.length) && (aiChatService.selectedMode === chatCommand.AnalyzeTechStacks || aiChatService.selectedMode === chatCommand.FindCustomers)">
          <div class="mb-3">
            <table>
              <thead>
                <tr>
                  <th *ngFor="let col of getDisplayColumns()">{{ col }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of getNormalizedData(message.buyercaddySource, message.geminiSources, true)">
                  <td *ngFor="let col of getDisplayColumns()">
                    <ng-container [ngSwitch]="col">
                      <span *ngSwitchCase="'CompanyDomain'">
                        <a [href]="'https://' + row[col]" target="_blank" *ngIf="row[col]">{{ row[col] }}</a>
                      </span>
                      <span *ngSwitchCase="'VendorDomain'">
                        <a [href]="'https://' + row[col]" target="_blank" *ngIf="row[col]">{{ row[col] }}</a>
                      </span>
                      <span *ngSwitchDefault>{{ row[col] }}</span>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <!-- 3. Company Cards -->
        <ng-container *ngIf="message.text.includes('[[COMPANY_CARD]]') && message.companies?.length">
          <company-card-component [companies]="message.companies || []"></company-card-component>
        </ng-container>

        <!-- 4. Generated UI Blocks -->
        <ng-container *ngIf="!message.isTyping && message.sender === 'bot' && getGeneratedUiBlocks(message).length">
          <div class="generated-ui-shell">
            <section
              class="generated-ui-block"
              *ngFor="let block of getGeneratedUiBlocks(message); trackBy: trackGeneratedUiBlock"
              [ngClass]="'generated-ui-block--' + block.type"
              [ngSwitch]="block.type"
            >
              <div class="generated-block-header">
                <h4>{{ block.title }}</h4>
                <span>{{ getGeneratedBlockKicker(block) }}</span>
              </div>

              <div class="generated-metric-grid" *ngSwitchCase="'metric_cards'">
                <div
                  class="generated-metric"
                  *ngFor="let item of getBlockItems(block)"
                  [ngClass]="'generated-tone--' + (item.tone || 'neutral')"
                >
                  <span class="generated-metric__label">{{ item.label }}</span>
                  <strong>{{ item.value }}</strong>
                  <small *ngIf="item.detail">{{ item.detail }}</small>
                </div>
              </div>

              <div class="generated-table-wrap" *ngSwitchCase="'score_table'">
                <table>
                  <thead>
                    <tr>
                      <th *ngFor="let column of getBlockColumns(block)">{{ column }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of getBlockRows(block)">
                      <td *ngFor="let cell of row">{{ cell }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="generated-echart-block" *ngSwitchCase="'bar_chart'">
                <div
                  class="generated-footprint-read"
                  *ngIf="getFootprintRead(block) as footprintRead"
                >
                  <div>
                    <div class="generated-trend-kicker">Install footprint</div>
                    <strong>{{ footprintRead.label }}</strong>
                    <p>{{ footprintRead.detail }}</p>
                  </div>
                  <div class="generated-footprint-metrics">
                    <span>
                      <small>Top segment</small>
                      <b>{{ footprintRead.topLabel }}</b>
                    </span>
                    <span>
                      <small>Detections</small>
                      <b>{{ footprintRead.topValue | number:'1.0-0' }}</b>
                    </span>
                    <span>
                      <small>Coverage share</small>
                      <b>{{ footprintRead.concentration }}%</b>
                    </span>
                  </div>
                </div>
                <div
                  echarts
                  [options]="getGeneratedEchartOptions(block)"
                  [autoResize]="true"
                  [initOpts]="{ renderer: 'svg' }"
                  (chartInit)="onGeneratedChartInit($event)"
                  (chartClick)="onGeneratedEchartClick($event, block)"
                  class="generated-echart generated-echart--ranking"
                ></div>
                <div class="generated-chart-signals" *ngIf="getChartSignals(block).length">
                  <button
                    type="button"
                    class="generated-signal"
                    *ngFor="let signal of getChartSignals(block)"
                    (click)="selectChartSignal(block, signal)"
                  >
                    <span>{{ signal.displayLabel || signal.label }}</span>
                    <b>{{ signal.total | number:'1.0-1' }}</b>
                  </button>
                </div>
                <div class="generated-selection" *ngIf="isGeneratedSelectionVisible(block)">
                  <strong>{{ generatedUiSelection?.title }}</strong>
                  <span *ngIf="generatedUiSelection?.detail">{{ generatedUiSelection?.detail }}</span>
                  <b *ngIf="generatedUiSelection?.value !== undefined">{{ generatedUiSelection?.value }}</b>
                </div>
              </div>

              <div class="generated-echart-block" *ngSwitchCase="'line_chart'">
                <div
                  echarts
                  [options]="getGeneratedEchartOptions(block)"
                  [autoResize]="true"
                  [initOpts]="{ renderer: 'svg' }"
                  (chartInit)="onGeneratedChartInit($event)"
                  (chartClick)="onGeneratedEchartClick($event, block)"
                  class="generated-echart generated-echart--line"
                ></div>
                <div class="generated-chart-signals" *ngIf="getChartSignals(block).length">
                  <button
                    type="button"
                    class="generated-signal"
                    *ngFor="let signal of getChartSignals(block)"
                    (click)="selectChartSignal(block, signal)"
                  >
                    <span>{{ signal.displayLabel || signal.label }}</span>
                    <b>{{ signal.total | number:'1.0-1' }}</b>
                  </button>
                </div>
                <div class="generated-selection" *ngIf="isGeneratedSelectionVisible(block)">
                  <strong>{{ generatedUiSelection?.title }}</strong>
                  <span *ngIf="generatedUiSelection?.detail">{{ generatedUiSelection?.detail }}</span>
                  <b *ngIf="generatedUiSelection?.value !== undefined">{{ generatedUiSelection?.value }}</b>
                </div>
              </div>

              <div class="generated-echart-block" *ngSwitchCase="'scatter_chart'">
                <div
                  echarts
                  [options]="getGeneratedEchartOptions(block)"
                  [autoResize]="true"
                  [initOpts]="{ renderer: 'svg' }"
                  (chartInit)="onGeneratedChartInit($event)"
                  (chartClick)="onGeneratedEchartClick($event, block)"
                  class="generated-echart generated-echart--scatter"
                ></div>
                <div class="generated-chart-signals" *ngIf="getChartSignals(block).length">
                  <button
                    type="button"
                    class="generated-signal"
                    *ngFor="let signal of getChartSignals(block)"
                    (click)="selectChartSignal(block, signal)"
                  >
                    <span>{{ signal.displayLabel || signal.label }}</span>
                    <b>{{ signal.total | number:'1.0-1' }}</b>
                  </button>
                </div>
                <div class="generated-selection" *ngIf="isGeneratedSelectionVisible(block)">
                  <strong>{{ generatedUiSelection?.title }}</strong>
                  <span *ngIf="generatedUiSelection?.detail">{{ generatedUiSelection?.detail }}</span>
                  <b *ngIf="generatedUiSelection?.value !== undefined">{{ generatedUiSelection?.value }}</b>
                </div>
              </div>

              <div class="generated-echart-block" *ngSwitchCase="'radar_chart'">
                <div
                  echarts
                  [options]="getGeneratedEchartOptions(block)"
                  [autoResize]="true"
                  [initOpts]="{ renderer: 'svg' }"
                  (chartInit)="onGeneratedChartInit($event)"
                  (chartClick)="onGeneratedEchartClick($event, block)"
                  class="generated-echart generated-echart--radar"
                ></div>
                <div class="generated-chart-signals" *ngIf="getChartSignals(block).length">
                  <button
                    type="button"
                    class="generated-signal"
                    *ngFor="let signal of getChartSignals(block)"
                    (click)="selectChartSignal(block, signal)"
                  >
                    <span>{{ signal.displayLabel || signal.label }}</span>
                    <b>{{ signal.total | number:'1.0-1' }}</b>
                  </button>
                </div>
                <div class="generated-selection" *ngIf="isGeneratedSelectionVisible(block)">
                  <strong>{{ generatedUiSelection?.title }}</strong>
                  <span *ngIf="generatedUiSelection?.detail">{{ generatedUiSelection?.detail }}</span>
                  <b *ngIf="generatedUiSelection?.value !== undefined">{{ generatedUiSelection?.value }}</b>
                </div>
              </div>

              <div class="generated-echart-block" *ngSwitchCase="'historical_trend_chart'">
                <div
                  class="generated-trend-read"
                  *ngIf="getHistoricalTrendRead(block) as trendRead"
                  [class.trend-accelerating]="trendRead.tone === 'accelerating'"
                  [class.trend-growing]="trendRead.tone === 'growing'"
                  [class.trend-stable]="trendRead.tone === 'stable'"
                  [class.trend-cooling]="trendRead.tone === 'cooling'"
                >
                  <div>
                    <div class="generated-trend-kicker">Adoption trend</div>
                    <strong>{{ trendRead.label }}</strong>
                    <p>{{ trendRead.detail }}</p>
                  </div>
                  <div class="generated-trend-metrics">
                    <span>
                      <small>{{ trendRead.changeLabel }}</small>
                      <b>{{ trendRead.change }}</b>
                    </span>
                    <span>
                      <small>Latest</small>
                      <b>{{ trendRead.latest | number:'1.0-1' }}</b>
                    </span>
                    <span>
                      <small>Peak</small>
                      <b>{{ trendRead.peak | number:'1.0-1' }}</b>
                    </span>
                  </div>
                </div>
                <div
                  echarts
                  [options]="getGeneratedEchartOptions(block)"
                  [autoResize]="true"
                  [initOpts]="{ renderer: 'svg' }"
                  (chartInit)="onGeneratedChartInit($event)"
                  (chartClick)="onGeneratedEchartClick($event, block)"
                  class="generated-echart generated-echart--historical"
                ></div>
                <div class="generated-event-list" *ngIf="getHistoricalEvents(block).length">
                  <button
                    type="button"
                    class="generated-event"
                    *ngFor="let event of getHistoricalEvents(block)"
                    (click)="selectHistoricalEvent(block, event)"
                  >
                    <strong>{{ event.date }}</strong>
                    <span>{{ event.label }}</span>
                    <small *ngIf="event.confidence">{{ event.confidence }}</small>
                  </button>
                </div>
                <div class="generated-chart-signals" *ngIf="getChartSignals(block).length">
                  <button
                    type="button"
                    class="generated-signal"
                    *ngFor="let signal of getChartSignals(block)"
                    (click)="selectChartSignal(block, signal)"
                  >
                    <span>{{ signal.displayLabel || signal.label }}</span>
                    <b>{{ signal.total | number:'1.0-1' }}</b>
                  </button>
                </div>
                <div class="generated-selection" *ngIf="isGeneratedSelectionVisible(block)">
                  <strong>{{ generatedUiSelection?.title }}</strong>
                  <span *ngIf="generatedUiSelection?.detail">{{ generatedUiSelection?.detail }}</span>
                  <b *ngIf="generatedUiSelection?.value !== undefined">{{ generatedUiSelection?.value }}</b>
                </div>
              </div>

              <div class="generated-timeline" *ngSwitchCase="'timeline'">
                <div class="generated-timeline__item" *ngFor="let item of getBlockItems(block)">
                  <div class="generated-timeline__horizon">{{ item.horizon }}</div>
                  <div class="generated-timeline__body">
                    <strong>{{ item.event }}</strong>
                    <span *ngIf="item.indicator">Indicator: {{ item.indicator }}</span>
                    <span *ngIf="item.risk">Risk: {{ item.risk }}</span>
                  </div>
                </div>
              </div>

              <div class="generated-echart-block" *ngSwitchCase="'diagram'">
                <div class="generated-diagram-toolbar">
                  <span>{{ block.diagramType }}</span>
                  <span *ngIf="block.layoutHint">{{ block.layoutHint }}</span>
                  <small>Drag nodes, zoom, click relationships</small>
                </div>
                <div
                  echarts
                  [options]="getGeneratedEchartOptions(block)"
                  [autoResize]="true"
                  [initOpts]="{ renderer: 'svg' }"
                  (chartInit)="onGeneratedChartInit($event)"
                  (chartClick)="onGeneratedEchartClick($event, block)"
                  class="generated-echart generated-echart--diagram"
                ></div>
                <div class="generated-diagram-inspector">
                  <div class="generated-diagram-groups" *ngIf="getDiagramGroups(block).length">
                    <button
                      type="button"
                      class="generated-diagram-pill"
                      *ngFor="let group of getDiagramGroups(block)"
                      (click)="selectDiagramGroup(block, group.name)"
                    >
                      <strong>{{ group.name }}</strong>
                      <span>{{ group.count }}</span>
                    </button>
                  </div>
                  <div class="generated-diagram-connections" *ngIf="getDiagramConnections(block).length">
                    <button
                      type="button"
                      class="generated-connection"
                      *ngFor="let connection of getDiagramConnections(block)"
                      (click)="selectDiagramConnection(block, connection)"
                    >
                      <span>{{ connection.from }}</span>
                      <mat-icon>arrow_forward</mat-icon>
                      <span>{{ connection.to }}</span>
                      <small>{{ connection.label }}</small>
                    </button>
                  </div>
                </div>
                <div class="generated-selection" *ngIf="isGeneratedSelectionVisible(block)">
                  <strong>{{ generatedUiSelection?.title }}</strong>
                  <span *ngIf="generatedUiSelection?.detail">{{ generatedUiSelection?.detail }}</span>
                  <b *ngIf="generatedUiSelection?.value !== undefined">{{ generatedUiSelection?.value }}</b>
                </div>
              </div>

              <ul class="generated-recommendations" *ngSwitchCase="'recommendations'">
                <li *ngFor="let item of getBlockItems(block)">{{ item }}</li>
              </ul>
            </section>
          </div>
        </ng-container>
        </div>

        <div
          class="generated-answer-actions ignore-pdf"
          *ngIf="canExportRachelAnswerPdf(message)"
        >
          <mat-icon
            style="color: #673ab7;"
            role="button"
            tabindex="0"
            [attr.aria-busy]="isRachelPdfExporting(message)"
            [attr.aria-disabled]="isRachelPdfExporting()"
            [attr.aria-label]="isRachelPdfExporting(message) ? 'Preparing BuyerCaddy trend PDF export' : 'Export BuyerCaddy trend answer as PDF'"
            [class.generated-answer-actions__icon--busy]="isRachelPdfExporting(message)"
            [class.spin-icon]="isRachelPdfExporting(message)"
            [style.opacity]="isRachelPdfExporting(message) ? 0.65 : 1"
            [ngbPopover]="isRachelPdfExporting(message) ? 'Preparing PDF export' : 'Export BuyerCaddy answer as PDF'"
            triggers="mouseenter:mouseleave"
            (click)="exportRachelAnswerPdf(message, messageExportContent)"
            (keydown.enter)="exportRachelAnswerPdf(message, messageExportContent)"
            (keydown.space)="$event.preventDefault(); exportRachelAnswerPdf(message, messageExportContent)"
          >{{ isRachelPdfExporting(message) ? 'hourglass_empty' : 'picture_as_pdf' }}</mat-icon>
        </div>

        <!-- 5. Action Icons -->
        <ng-container
          *ngIf="
            !message.isTyping
            && message.sender === 'bot'
            && isAIAdmin
            && (aiChatService.selectedMode === chatCommand.AnalyzeTechStacks
              || aiChatService.selectedMode === chatCommand.FindCustomers)">
          
           <div class="d-flex flex-row justify-content-end mt-2 gap-2 ignore-pdf" *ngIf="aiChatService.selectedMode === chatCommand.FindCustomers">
            <mat-icon style="color: #673ab7;" *ngIf="message.geminiSources?.length > 0" role="button" [ngbPopover]="'Add new companies to BuyerCaddy ' + message.geminiSources?.length" triggers="mouseenter:mouseleave" (click)="openImportDialog(message.geminiSources,'companies')">post_add</mat-icon>
            <mat-icon style="color: #673ab7;" *ngIf="(message.buyercaddySource?.length ?? 0) > 0 || (message.geminiSources?.length ?? 0) > 0" role="button" [ngbPopover]="'Export Companies'" triggers="mouseenter:mouseleave" (click)="exportData('company',message.buyercaddySource,message.geminiSources)">download</mat-icon>
           </div>
           <div class="d-flex flex-row justify-content-end mt-2 gap-2 ignore-pdf" *ngIf="aiChatService.selectedMode === chatCommand.AnalyzeTechStacks">
            <mat-icon *ngIf="message.geminiSources?.length > 0" [ngbPopover]="'Add New Products to Company Tech Stack ' + message.geminiSources?.length" triggers="mouseenter:mouseleave" style="color: #673ab7;" role="button" (click)="openImportDialog(message.geminiSources,'products')">post_add</mat-icon>
            <mat-icon *ngIf="(message.buyercaddySource?.length ?? 0) > 0 || (message.geminiSources?.length ?? 0) > 0" style="color: #673ab7;" role="button" [ngbPopover]="'Export Tech Stack'" triggers="mouseenter:mouseleave" (click)="exportData('product',message.buyercaddySource,message.geminiSources)">download</mat-icon>
          </div>
          
        </ng-container>

        <div *ngIf="message.isTyping" class="typing-indicator">
          <span
            *ngIf="message.loadingMessage"
            class="typing-hint"
            [ngClass]="(message.loadingMessageVersion ?? 0) % 2 === 0 ? 'typing-animate-a' : 'typing-animate-b'"
          >
            {{ message.loadingMessage }}
          </span>
          <span class="dot"></span><span class="dot"></span><span class="dot"></span>
        </div>
        <div class="timestamp ignore-pdf" *ngIf="!message.isTyping">{{ message.timestamp | date: 'shortTime' }}</div>
      </mat-card>
    </div>
  </div>

  <button
    type="button"
    class="jump-latest"
    *ngIf="showJumpToLatest"
    (click)="jumpToLatest()"
  >
    <mat-icon aria-hidden="true">south</mat-icon>
    <span>Jump to latest</span>
  </button>

  <div class="chat-footer">
  <section class="rachel-mode-bar" aria-label="Rachel modes">
    <div class="rachel-mode-bar__header">
      <span class="rachel-mode-bar__title">Modes</span>
      <span class="rachel-mode-bar__auto" *ngIf="aiChatService.isAutoModeEnabled">
        <mat-icon aria-hidden="true">auto_awesome</mat-icon>
        Auto
      </span>
    </div>

    <div class="rachel-mode-bar__chips">
      <button
        type="button"
        class="rachel-mode-chip"
        *ngFor="let chip of modeChips"
        [class.rachel-mode-chip--active]="aiChatService.selectedMode === chip.command"
        [disabled]="aiChatService.isLoading"
        [hidden]="!canShowModeChip(chip)"
        (click)="chipSelected(chip.command)"
      >
        <mat-icon aria-hidden="true">{{ chip.icon }}</mat-icon>
        <span>{{ chip.label }}</span>
      </button>

      <div
        *ngIf="isAIAdmin && aiChatService.selectedMode === chatCommand.FindCustomers"
        class="rachel-mode-expansive"
      >
        <span>Expansive</span>
        <mat-slide-toggle
          color="primary"
          [checked]="aiChatService.aggressiveCustomersMode"
          (change)="onAggressiveModeToggle($event)"
          [disabled]="aiChatService.isLoading"
          aria-label="Toggle Expansive mode"
        ></mat-slide-toggle>
      </div>
    </div>
  </section>

  <mat-form-field appearance="outline" class="chat-input" subscriptSizing="dynamic">
    <input
      matInput
      [(ngModel)]="userInput"
      autofocus
      placeholder="Ask Rachel anything..."
      (keyup)="onKeyUp($event)"
      #inputField
      class="futuristic-input"
    >
    <button
      mat-icon-button
      matSuffix
      [disabled]="aiChatService.isLoading"
      [matMenuTriggerFor]="suggestionsMenu"
      matTooltip="Show suggestions"
      class="stylish-button suggestion-button "
    >
      <mat-icon style="color: cornflowerblue;">question_mark</mat-icon>
    </button>
    <button
      mat-icon-button
      color="primary"
      matSuffix
      (click)="sendMessage()"
      [disabled]="!userInput || aiChatService.isLoading"
      class="stylish-button send-button"
    >
      <mat-icon>send</mat-icon>
    </button>

    <mat-menu #suggestionsMenu="matMenu" panelClass="rachel-suggestions-menu">
      <div class="suggestions-menu__header">Examples</div>

      <button
        mat-menu-item
        *ngFor="let suggestion of suggestions"
        (click)="userInput = suggestion"
        class="stylish-menu-item"
      >
        {{ suggestion }}
      </button>
    </mat-menu>
  </mat-form-field>
  </div>
</div>
